export default "__VITE_ASSET__DfPgMMGf__"